import { useEffect } from 'react';
import { useQuery } from 'react-query';
import { FetchSearchesParams, SearchEntity } from 'v2/models';
import restFactory from '../utils/restFactory';
interface searchQueryResponse {
  results: SearchEntity[];
  count: number;
  next: string | null;
  previous: string | null;
}

export interface PostUseQueryActions {
  onSuccess?: (data: searchQueryResponse) => void;
  onError?: () => void;
  onSettled?: () => void;
  refetchInterval?: (data: searchQueryResponse | undefined) => false | number;
  refetchOnWindowsFocus?: (data: searchQueryResponse | undefined) => boolean;
}

export function getKey(
  params: FetchSearchesParams = {},
  dependencies: string[] = []
) {
  return ['get requests list', params, ...dependencies];
}

export const fetchSearches = async (params: FetchSearchesParams) => {
  return await restFactory.get<searchQueryResponse>(
    `/dj/api/v1/search/details/`,
    params
  );
};

export default function useFetchSearchesPaginated(
  params: FetchSearchesParams,
  dependencies: string[],
  postUseQueryActions?: PostUseQueryActions
) {
  const page = params.page;
  const useQueryServices = useQuery(
    getKey(params, dependencies),
    async () => fetchSearches(params),
    {
      cacheTime: 0,
      refetchInterval: (data) =>
        postUseQueryActions?.refetchInterval?.(data) || false,
      refetchOnWindowFocus: (data) =>
        postUseQueryActions?.refetchOnWindowsFocus?.(data.state.data) || false,
      onSuccess: (data) => postUseQueryActions?.onSuccess?.(data),
      onError: () => postUseQueryActions?.onError?.(),
      onSettled: () => postUseQueryActions?.onSettled?.(),
    }
  );

  useEffect(() => {
    useQueryServices.refetch();
  }, [page]);

  return useQueryServices;
}
